import {Elements} from "./uischema/Elements";

export class UiSchema{

    type: string;
    label: string;
    elements: Array<Elements>;

    public constructor(type: string, label: string, elements: Array<Elements> = []) {
        this.type = type;
        this.label = label;
        this.elements = elements;
    }

}
